// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const tl: ChromeTranslations = {
  'nav.nextPage': 'susunod na pahina →',
  'nav.previousPage': '← nakaraang pahina',
  'nav.continueToLevel': 'magpatuloy sa level →',
  'nav.backToMenu': 'bumalik sa menu →',
  'howto.page': 'pahina {n} ng {total}',
  'options.title': 'Mga Opsyon',
  'ui.language': 'Wika',
};
